// extracted by mini-css-extract-plugin
module.exports = {"root":"PublicMessages_root__2v1bo"};